/**
 * JS-consumed mirror of the design tokens defined in `app/tokens.css`.
 *
 * Use these ONLY where a value must be passed to inline `style={{}}` or to a
 * non-Tailwind API (canvas, charts, third-party libs). For everything className-
 * based, prefer the Tailwind utilities backed by the same tokens
 * (e.g. `bg-brand-purple`, `text-ink`, `shadow-cta-yellow`).
 *
 * Each entry resolves the same `--token` custom property so there is a single
 * source of truth. `cssVar(name)` returns `rgb(var(--name))`; pass an alpha to
 * get `rgb(var(--name) / a)`.
 */

export function cssVar(name: string, alpha?: number): string {
  return alpha === undefined ? `rgb(var(--${name}))` : `rgb(var(--${name}) / ${alpha})`;
}

/**
 * Brand tokens addressable from JS, as live CSS-variable refs. Kept to the set
 * actually consumed in inline styles; for anything else use `cssVar(name)`
 * directly or (preferably) the Tailwind utilities.
 */
export const tokens = {
  brandPurple: cssVar("brand-purple"),
  ink: cssVar("ink"),
  ctaYellowBright: cssVar("cta-yellow-bright"),
  ctaOrange: cssVar("cta-orange"),
} as const;

export type TokenName = keyof typeof tokens;
